import { gql } from '@apollo/client/core';
import { Trans } from '@lingui/macro';
import React from 'react';
import useProduct from '../useProduct';
import { DynamicComponent } from '../../';
import CertificationsIcons from './CertificationsIcons';

export default function Certifications({ product: data, style }) {
  const product = useProduct(data);
  if (!hasContent(product)) return null;
  return (
    <DynamicComponent.Wrapper style={style}>
      <DynamicComponent.Label style={{ marginBottom: 8 }}>
        <Trans>Certifications</Trans>
      </DynamicComponent.Label>
      <CertificationsIcons product={product} />
    </DynamicComponent.Wrapper>
  );
}

Certifications.hasContent = hasContent;

function hasContent({
  localCertifications,
  internationalCertifications,
  isVegan,
  isVegetarian,
  isCertifiedOrganic,
  isBiodynamic,
}) {
  if (localCertifications?.length > 0) return true;
  if (internationalCertifications?.length > 0) return true;
  if (isVegan || isVegetarian || isCertifiedOrganic || isBiodynamic)
    return true;
  return false;
}

Certifications.fragment = gql`
  fragment Certifications on Product {
    localCertifications {
      certificationCode: name(format: RAW)
      certificationName: name
    }
    internationalCertifications {
      certificationCode: name(format: RAW)
      certificationName: name
    }
    isVegan
    isVegetarian
    isCertifiedOrganic
    isBiodynamic
  }
`;
